import { Container } from "@mui/material";
import React from "react";
import Hero from "../components/hero/Hero";
import TaxReturnServices from "../components/services/Services";
// import TaxCalculator from '../components/tax-calculator/TaxCalculator'
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function ServicePage() {
  const location = useLocation();

useEffect(() => {
  if (location.hash) {
    const timeout = setTimeout(() => {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // 100ms delay to wait for DOM

    return () => clearTimeout(timeout); // Cleanup
  }
}, [location]);

  const desc ='At Aspire Tax and Bookkeeping, we offer comprehensive solutions tailored to your unique financial needs. From BAS lodgements and payroll management to expert tax advice and business structuring, our certified professionals ensure accuracy, compliance, and peace of mind — so you can focus on what matters most: growing your business.'
  return (
    <>
     <Hero 
        contentAlign='center'
        title="Professional Tax and Bookkeeping Services You Can Trust"
        titleAlign='center'
        description={desc}
        descriptionAlign = 'center'
        backgroundImage={'url(/assets/taxation.webp)'}
        primaryButton={{
        text: 'Book a Session',
        className: 'hero-box__button',
        route:'/book-now',
        }}
        
        secondayButton={{
        text: 'Explore Our Services',
        className: 'hero-box__transparentButton',
        route:'#services-section',
        }}
      />
     
      
      
      <Container maxWidth="xl" id="services-section">
        <TaxReturnServices/>  
      </Container>

      {/* <Container maxWidth="xl">
        <TaxCalculator/>  
      </Container> */}
    </>
  );
}

export default ServicePage;
